"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_hook_form_1 = require("react-hook-form");
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importDefault(require("react"));
const mobx_1 = require("mobx");
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const SearchControlSection = (props) => {
    const { searchCriteriaStore, resetSearchFn, disableSearchButtons, extraButtons } = props;
    const searchValues = (0, react_hook_form_1.useWatch)({ name: 'search', defaultValue: [] });
    const filterValues = (0, react_hook_form_1.useWatch)({ name: 'filter', defaultValue: [] });
    const isResetButtonDisabled = (0, mobx_1.computed)(() => {
        if (disableSearchButtons) {
            return true;
        }
        if (searchCriteriaStore.searchCriteria.length > searchCriteriaStore.defaultSearchCriteriaLength) {
            return false;
        }
        return !searchCriteriaStore.isCriteriaSearchReady(searchValues, filterValues);
    });
    return (react_1.default.createElement("div", { className: 'button-wrapper' },
        react_1.default.createElement("div", { className: "criteria-buttons" },
            resetSearchFn && (react_1.default.createElement("a", { className: (0, clsx_1.default)('link bold', isResetButtonDisabled.get() && 'disabled'), type: 'secondary', onClick: isResetButtonDisabled.get() ? undefined : resetSearchFn }, "Reset Search")),
            extraButtons && (react_1.default.createElement("div", { className: 'extra-button-wrapper' }, extraButtons.map((extraButton) => extraButton))),
            react_1.default.createElement(Button_1.Button, { submitType: 'submit', mainColor: true, className: "control-button search", type: "primary", disabled: disableSearchButtons || !searchCriteriaStore.isCriteriaSearchReady(searchValues, filterValues) }, "Search"))));
};
exports.default = SearchControlSection;
